<template>
  <div class="student-list">
    <div class="list-table__title">Students List</div>
    <b-table
      table-responsive
      striped
      hover
      Outlined
      show-empty
      :empty-text="'No data available'"
      :items="students"
      :fields="fields"
      :table-class="'list-table text-center'"
      :thead-class="'list-table__head'"
      :tbody-class="'list-table__body'"
    >
      <template #head(studentNumber)="data">
        <div
          class="thead-item"
          @click="sortBy('studentNumber')"
          :class="sortKey === 'studentNumber' ? sortDirection : null"
        >
          {{ data.label }}
        </div>
      </template>
      <template #head(name)="data">
        <div
          class="thead-item"
          @click="sortBy('studentNameEn')"
          :class="sortKey === 'studentNameEn' ? sortDirection : null"
        >
          {{ data.label }}
        </div>
      </template>
      <template #head(nameJp)="data">
        <div
          class="thead-item"
          @click="sortBy('studentName')"
          :class="sortKey === 'studentName' ? sortDirection : null"
        >
          {{ data.label }}
        </div>
      </template>
      <template #cell(A)="student">
        <div
          class="thead-item"
        >
          {{ checkCourceCodes(student.item.id, 'A') }}
        </div>
      </template>
      <template #cell(B)="student">
        <div
          class="thead-item"
        >
          {{ checkCourceCodes(student.item.id, 'B') }}
        </div>
      </template>
      <template #cell(C)="student">
        <div
          class="thead-item"
        >
          {{ checkCourceCodes(student.item.id, 'C') }}
        </div>
      </template>
      <template #cell(D)="student">
        <div
          class="thead-item"
        >
          {{ checkCourceCodes(student.item.id, 'D') }}
        </div>
      </template>
      <template #cell(α)="student">
        <div
          class="thead-item"
        >
          {{ checkCourceCodes(student.item.id, 'α') }}
        </div>
      </template>
      <template #cell(β)="student">
        <div
          class="thead-item"
        >
          {{ checkCourceCodes(student.item.id, 'β') }}
        </div>
      </template>
      <template #cell(intensive)="student">
        <div
          class="thead-item"
        >
          {{ checkCourceCodes(student.item.id, 'I') }}
        </div>
      </template>
      <template #cell(Detail)="student">
        <b-button
          pill
          variant="outline-secondary"
          :to="{name: 'StudentDetail', params: { id: student.item.id }}"
        >
          Detail
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import _ from 'lodash'
import { Student, StudentConditions } from '../../../store/students/types';

@Component
export default class StudentTable extends Vue {
  private sortKey: 'studentNumber'|'studentName'|'studentNameEn'|null = null

  private sortDirection: 'asc'|'desc'|null = null

  fields = [
    {
      key: 'studentNumber',
      label: 'Student number',
    },
    {
      key: 'name',
      label: 'Student Name \n (Alphabet)',
    },
    {
      key: 'nameJp',
      label: 'Student Name',
    },
    { key: 'A' },
    { key: 'B' },
    { key: 'C' },
    { key: 'D' },
    { key: 'α' },
    { key: 'β' },
    { key: 'intensive' },
    {
      key: 'email1',
      label: 'Email',
    },
    { key: 'Detail' },
  ]

  private get students(): Student[] {
    return this.$store.state.students.students
  }

  private get current(): number {
    return this.$store.state.students.pager.current
  }

  private get conditions(): StudentConditions {
    return this.$store.state.students.conditions
  }

  private checkCourceCodes(id: string, type: string) {
    const result = (() => {
      const codes = _.chain(this.students)
        .find({ id })
        .value()
        .courseCodes

      if (type === 'I') {
        return _.chain(codes)
          .map((code: string) => code.substr(4, 2))
          .filter((courseContent: string) => _.includes(courseContent, type))
          .value()
      }
      return _.chain(codes)
        .map((code: string) => code.substr(-2))
        .filter((courseContent: string) => _.includes(courseContent, type))
        .value()
    })()

    if (result.length !== 0) {
      return '◯'
    }
    return ''
  }

  /**
   * @param {string} ソートのキー
  */
  private sortBy(key: 'studentNumber'|'studentName'|'studentNameEn') {
    if (this.sortKey !== key) {
      this.sortKey = key;
      this.sortDirection = 'asc'
    } else {
      const directions = ['asc', 'desc', null];
      const directionPosition = _.indexOf(directions, this.sortDirection)
      this.sortDirection = directions[(directionPosition + 1) % 3] as 'asc'|'desc'|null

      if (this.sortDirection === null) {
        // ディレクションが一周してnullになった場合はソートのキーも解除
        this.sortKey = null
      }
    }

    if (this.sortKey && this.sortDirection) {
      this.$store.dispatch(
        'fetchStudents',
        {
          conditions: this.conditions,
          page: this.current,
          sortBy: { key: this.sortKey, direction: this.sortDirection },
        },
      )
    }
  }
}
</script>

<style>
.student-list .list-table .list-table__head {
  font-size: .7rem;
}

.student-list .list-table .list-table__head th {
  font-size: .7rem;
  vertical-align: middle;
  white-space: pre-line;
  padding:0;
}

.student-list .list-table .list-table__head .thead-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem .75rem;
}

.student-list .list-table .list-table__body td {
  font-size: .8rem;
  padding: 1rem;
}

.asc::after {
  margin-left:5px;
  content: "▼";
}
.desc::after {
  margin-left:5px;
  content: "▲";
}
</style>
